import { lazyRouteComponent } from "@tanstack/react-router";
import { Headset } from "lucide-react";

import type { PageDef } from "@/app/registry";

export type CrmTab = "today" | "ra" | "leads" | "follow-ups";
const TABS: CrmTab[] = ["today", "ra", "leads", "follow-ups"];

export const pages: PageDef[] = [
  {
    path: "/app/crm",
    title: "Sales console",
    component: lazyRouteComponent(() => import("./CrmPage"), "CrmPage"),
    nav: { label: "Sales console", icon: Headset, group: "System", order: 3 },
    // Employees (V036) and admins; the server checks the role on every /crm route.
    roles: ["employee", "admin"],
    employees: true,
    validateSearch: (s) => ({
      tab: TABS.includes(s.tab as CrmTab) ? (s.tab as CrmTab) : "today",
    }),
  },
];
